//constants
import { TOPIC_TEMPLATES } from 'constants/topicTemplates'

/**
 * 
 * @param {number} typeId 
 * @returns {string}
 */
export const getSlideType = typeId => TOPIC_TEMPLATES[typeId]?.type || ''